// Curated Indian city list for place-of-birth dropdown (with a few overseas hubs).
// Not exhaustive — the picker also allows a free-text entry via "Other…"

export const INDIAN_CITIES = [
  // Metro / tier 1
  "Ahmedabad", "Bengaluru", "Chennai", "Delhi", "Hyderabad",
  "Kolkata", "Mumbai", "New Delhi", "Pune",

  // Rajasthan
  "Ajmer", "Alwar", "Banswara", "Baran", "Barmer", "Beawar",
  "Bharatpur", "Bhilwara", "Bikaner", "Bundi", "Chittorgarh",
  "Churu", "Dausa", "Dholpur", "Dungarpur", "Ganganagar",
  "Hanumangarh", "Jaipur", "Jaisalmer", "Jalore", "Jhalawar",
  "Jhunjhunu", "Jodhpur", "Karauli", "Kota", "Nagaur", "Pali",
  "Pratapgarh", "Rajsamand", "Sawai Madhopur", "Sikar", "Sirohi",
  "Tonk", "Udaipur",

  // UP
  "Agra", "Aligarh", "Allahabad", "Ayodhya", "Bareilly",
  "Faizabad", "Firozabad", "Ghaziabad", "Gorakhpur", "Jhansi",
  "Kanpur", "Lucknow", "Mathura", "Meerut", "Moradabad",
  "Noida", "Prayagraj", "Saharanpur", "Varanasi",

  // MP
  "Bhopal", "Gwalior", "Indore", "Jabalpur", "Rewa", "Sagar",
  "Satna", "Ujjain",

  // Bihar / Jharkhand / WB / Odisha
  "Bhagalpur", "Bodh Gaya", "Darbhanga", "Gaya", "Muzaffarpur",
  "Patna", "Purnia",
  "Bokaro", "Dhanbad", "Jamshedpur", "Ranchi",
  "Asansol", "Durgapur", "Howrah", "Kharagpur", "Siliguri",
  "Bhubaneswar", "Cuttack", "Rourkela", "Sambalpur",

  // Punjab / Haryana / HP / J&K / Uttarakhand
  "Amritsar", "Bathinda", "Chandigarh", "Jalandhar", "Ludhiana",
  "Mohali", "Pathankot", "Patiala",
  "Ambala", "Faridabad", "Gurgaon", "Gurugram", "Hisar",
  "Karnal", "Panchkula", "Panipat", "Rohtak", "Sonipat",
  "Dharamshala", "Kullu", "Manali", "Shimla",
  "Jammu", "Srinagar",
  "Dehradun", "Haridwar", "Nainital", "Rishikesh", "Roorkee",

  // Gujarat / Maharashtra / Goa
  "Anand", "Bhavnagar", "Gandhinagar", "Junagadh", "Rajkot",
  "Surat", "Vadodara", "Vapi",
  "Aurangabad", "Kolhapur", "Nagpur", "Nashik", "Solapur", "Thane",
  "Panaji", "Vasco da Gama", "Margao",

  // South (rest)
  "Coimbatore", "Erode", "Kanyakumari", "Madurai", "Salem",
  "Thanjavur", "Tirunelveli", "Trichy", "Vellore",
  "Alappuzha", "Ernakulam", "Kochi", "Kollam", "Kottayam",
  "Kozhikode", "Malappuram", "Palakkad", "Thiruvananthapuram", "Thrissur",
  "Belgaum", "Davangere", "Hubballi", "Mangaluru", "Mysuru",
  "Shivamogga", "Udupi",
  "Guntur", "Kakinada", "Kurnool", "Nellore", "Rajahmundry",
  "Tirupati", "Vijayawada", "Visakhapatnam", "Warangal",

  // North East
  "Agartala", "Aizawl", "Dibrugarh", "Dimapur", "Gangtok",
  "Guwahati", "Imphal", "Itanagar", "Kohima", "Shillong", "Silchar",

  // Overseas hubs (NRIs)
  "Abu Dhabi", "Auckland", "Chicago", "Dallas", "Doha",
  "Dubai", "Houston", "London", "Los Angeles", "Melbourne",
  "New York", "San Francisco", "Singapore", "Sydney", "Toronto",
];
